export const TASK_CATEGORIES = [
  "Blog", "Pinterest", "Facebook", "Instagram", "Email",
  "App", "Website", "Business", "School", "Personal",
];

export const CONTENT_STATUSES = ["Idea", "Draft", "Ready", "Scheduled", "Published"];

export const CONTENT_PLATFORMS = [
  { key: "blog", label: "Blog" },
  { key: "facebook", label: "Facebook" },
  { key: "instagram", label: "Instagram" },
  { key: "threads", label: "Threads" },
  { key: "linkedin", label: "LinkedIn" },
  { key: "pinterest", label: "Pinterest" },
  { key: "email", label: "Email" },
  { key: "youtube_short", label: "YouTube Short" },
];

// Canonical content platforms the OS understands (mirrors backend PLATFORM_CATALOG).
export const PLATFORM_CATALOG = [
  { key: "blog", label: "Blog" },
  { key: "facebook", label: "Facebook" },
  { key: "instagram", label: "Instagram" },
  { key: "linkedin", label: "LinkedIn" },
  { key: "pinterest", label: "Pinterest" },
  { key: "email", label: "Email" },
  { key: "youtube", label: "YouTube" },
  { key: "threads", label: "Threads" },
  { key: "x", label: "X (Twitter)" },
  { key: "tiktok", label: "TikTok" },
  { key: "newsletter", label: "Newsletter" },
];

export const DEFAULT_PLATFORM_KEYS = ["blog", "facebook", "instagram", "linkedin", "pinterest", "email", "youtube"];

export const IDEA_CATEGORIES = [
  "Blog ideas", "Social post ideas", "Video ideas", "Product ideas",
  "Offer ideas", "Email ideas", "Lead magnet ideas", "Business ideas", "General",
];

export const IDEA_STATUSES = ["New", "Exploring", "Ready", "Converted"];

export const SOP_CATEGORIES = [
  "Write and publish a blog post", "Plan a week of social content",
  "Schedule and publish social posts", "Write and send an email",
  "Update the website", "Launch a new offer",
  "Review monthly metrics", "Onboard a new client or customer",
];

export const STATUS_TONE = {
  Idea: "bg-muted text-muted-foreground",
  Draft: "bg-accent/20 text-secondary",
  Ready: "bg-primary/15 text-primary",
  Scheduled: "bg-secondary/15 text-secondary",
  Published: "bg-primary/90 text-primary-foreground",
  New: "bg-muted text-muted-foreground",
  Exploring: "bg-accent/20 text-secondary",
  Converted: "bg-primary/15 text-primary",
};
